import React from 'react'
import SALink from 'components/SALink'
import { OwnerInfoSection, OwnerAvatar, OwnerInfoLine } from 'styles/algolia/collection/header'
import HeaderConnector, { ConnectorProps as HeaderProps } from '../../connectors/Header'
import { capitalizeString } from 'lib/helpers'

export default HeaderConnector((props: HeaderProps) => {
  const { avatarUrl, collectionCount, name, ownerId, ownerTitle } = props
  const capitalizedName = capitalizeString(name)

  return (
    <OwnerInfoSection>
      <SALink href={`/account/profile/${ownerId}`} title={`View profile of ${capitalizedName}`}>
        <OwnerAvatar src={avatarUrl} alt={capitalizedName} />
      </SALink>

      <div data-type='collection-info' title='Collection info'>
        <OwnerInfoLine>
          <h6 className='defaultTypographyH6'>
            {collectionCount} Artworks curated by{' '}
            <SALink
              href={`/account/profile/${ownerId}`}
              title={`View profile of ${capitalizedName}`}
            >
              {capitalizedName}
            </SALink>
          </h6>
        </OwnerInfoLine>
        {ownerTitle && <OwnerInfoLine titleLine>{ownerTitle}</OwnerInfoLine>}
      </div>
    </OwnerInfoSection>
  )
})
